<script generics="T" lang="ts">
	import SelectedOption from './SelectedOption.svelte'
	import { isOptionOfValue } from './select'
	import { type SelectOption } from './selectOption'
	import { _ } from '@repo/i18n'
	import { createEventDispatcher } from 'svelte'

	interface Props {
		values?: T[]
		options: SelectOption<T>[]
		multiple: boolean
		autocomplete?: boolean
		selectedOptionSlot?: import('svelte').Snippet<[{ option: SelectOption<T>; value: T }]>
	}

	let { values = [], options, multiple, autocomplete, selectedOptionSlot }: Props = $props()

	function getOption(value: T) {
		return options.find((option) => isOptionOfValue(option, value))
	}

	const dispatch = createEventDispatcher()

	function handleRemoveOption(option: SelectOption<T>) {
		dispatch('removeOption', option)
	}

	function handleRemoveValue(value: T) {
		dispatch('removeValue', value)
	}

	function handleRemoveAll() {
		dispatch('removeAll')
	}
</script>

{#if !autocomplete && values.length > 3}
	<SelectedOption on:remove={handleRemoveAll}>
		{$_('select.selected', { values: { count: values.length } })}
	</SelectedOption>
{:else}
	{#each values as value, index (index)}
		{@const option = getOption(value)}

		{#if multiple}
			<SelectedOption
				customColor={option?.color}
				disabled={option?.disabled}
				on:remove={() => (option ? handleRemoveOption(option) : handleRemoveValue(value))}
			>
				{#if selectedOptionSlot}{@render selectedOptionSlot({ option, value })}{:else}
					{option?.label || value}
				{/if}
			</SelectedOption>
		{:else if selectedOptionSlot}{@render selectedOptionSlot({ option, value })}{:else}
			{option?.label || value}
		{/if}
	{/each}
{/if}
